import { createSlice } from '@reduxjs/toolkit';
import { getTicket, getTicketInformation, saveTicket,getTicketHistory,deleteTicket,saveTicketConversation,getTicketConversation } from 'services/actions/ticketActions';

interface SecurityState {
    ticketLoading: boolean;
    ticketError: any;
    ticketSuccess: boolean;
    ticketInfo: any;
    ticketInformationLoading: boolean;
    ticketInformationError: any;
    ticketInformationSuccess: boolean;
    ticketInformation: any;
    saveTicketLoading: boolean;
    saveTicketError: any;
    saveTicketSuccess: boolean;
    saveTicketInfo: any;
    ticketHistoryLoading: boolean;
    ticketHistoryError: any;
    ticketHistorySuccess: boolean;
    ticketHistoryInfo: any;
    ticketDeleteLoading: boolean;
    ticketDeleteError: any;
    ticketDeleteSuccess: boolean;
    ticketDeleteInfo: any;
    saveTicketConversationLoading: boolean;
    saveTicketConversationError: any;
    saveTicketConversationSuccess: boolean;
    saveTicketConversationInfo: any;
    getTicketConversationLoading: boolean;
    getTicketConversationError: any;
    getTicketConversationSuccess: boolean;
    getTicketConversationInfo: any;
}

const initialState: SecurityState = {
   
    ticketLoading: false,
    ticketError: null,
    ticketSuccess: false,
    ticketInfo: null,
    ticketInformationLoading: false,
    ticketInformationError: null,
    ticketInformationSuccess: false,
    ticketInformation: null,
    saveTicketLoading: false,
    saveTicketError: null,
    saveTicketSuccess: false,
    saveTicketInfo: null,
    ticketHistoryLoading: false,
    ticketHistoryError: null,
    ticketHistorySuccess: false,
    ticketHistoryInfo: null,
    ticketDeleteLoading: false,
    ticketDeleteError: null,
    ticketDeleteSuccess: false,
    ticketDeleteInfo: null,
    saveTicketConversationLoading: false,
    saveTicketConversationError: null,
    saveTicketConversationSuccess: false,
    saveTicketConversationInfo: null,
    getTicketConversationLoading: false,
    getTicketConversationError: null,
    getTicketConversationSuccess: false,
    getTicketConversationInfo: null,
};

const securitySlice = createSlice({
    name: 'ticket',
    initialState,
    reducers: {resetSaveTicketState: (state) => {
            state.saveTicketLoading = false;
            state.saveTicketSuccess = false;
            state.saveTicketError = null;
            state.saveTicketInfo = null;
             state.ticketDeleteSuccess = false;
        },},
    extraReducers: (builder) => {
        builder
            .addCase(getTicket.pending, (state) => {
                state.ticketLoading = true;
                state.ticketError = null;
                state.ticketSuccess = false;
                state.ticketInfo = null;
            })
            .addCase(getTicket.fulfilled, (state, { payload }) => {
                state.ticketLoading = false;
                state.ticketInfo = payload;
                state.ticketSuccess = true;
            })
            .addCase(getTicket.rejected, (state, { payload }) => {
                state.ticketLoading = false;
                state.ticketError = payload;
                state.ticketSuccess = false;
                state.ticketInfo = null;
            })
            .addCase(getTicketInformation.pending, (state) => {
                state.ticketInformationLoading = true;
                state.ticketInformationError = null;
                state.ticketInformationSuccess = false;
                state.ticketInformation = null;
            })
            .addCase(getTicketInformation.fulfilled, (state, { payload }) => {
                state.ticketInformationLoading = false;
                state.ticketInformation = payload;
                state.ticketInformationSuccess = true;
            })
            .addCase(getTicketInformation.rejected, (state, { payload }) => {
                state.ticketInformationLoading = false;
                state.ticketInformationError = payload;
                state.ticketInformationSuccess = false;
                state.ticketInformation = null;
            })
            .addCase(saveTicket.pending, (state) => {
                state.saveTicketLoading = true;
                state.saveTicketError = null;
                state.saveTicketSuccess = false;
                state.saveTicketInfo = null;
            })
            .addCase(saveTicket.fulfilled, (state, { payload }) => {
                state.saveTicketLoading = false;
                state.saveTicketInfo = payload;
                state.saveTicketSuccess = true;
            })
            .addCase(saveTicket.rejected, (state, { payload }) => {
                state.saveTicketLoading = false;
                state.saveTicketError = payload;
                state.saveTicketSuccess = false;
                state.saveTicketInfo = null;
            })
            .addCase(getTicketHistory.pending, (state) => {
                state.ticketHistoryLoading = true;
                state.ticketHistoryError = null;
                state.ticketHistorySuccess = false;
                state.ticketHistoryInfo = null;
            })
            .addCase(getTicketHistory.fulfilled, (state, { payload }) => {
                state.ticketHistoryLoading = false;
                state.ticketHistoryInfo = payload;
                state.ticketHistorySuccess = true;
            })
            .addCase(getTicketHistory.rejected, (state, { payload }) => {
                state.ticketHistoryLoading = false;
                state.ticketHistoryError = payload;
                state.ticketHistorySuccess = false;
                state.ticketHistoryInfo = null;
            })
            .addCase(deleteTicket.pending, (state) => {
                state.ticketDeleteLoading = true;
                state.ticketDeleteError = null;
                state.ticketDeleteSuccess = false;
                state.ticketDeleteInfo = null;
            })
            .addCase(deleteTicket.fulfilled, (state, { payload }) => {
                state.ticketDeleteLoading = false;
                state.ticketDeleteInfo = payload;
                state.ticketDeleteSuccess = true;
            })
            .addCase(deleteTicket.rejected, (state, { payload }) => {
                state.ticketDeleteLoading = false;
                state.ticketDeleteError = payload;
                state.ticketDeleteSuccess = false;
                state.ticketDeleteInfo = null;
            })
            .addCase(saveTicketConversation.pending, (state) => {
                state.saveTicketConversationLoading = true;
                state.saveTicketConversationError = null;
                state.saveTicketConversationSuccess = false;
                state.saveTicketConversationInfo = null;
            })
            .addCase(saveTicketConversation.fulfilled, (state, { payload }) => {
                state.saveTicketConversationLoading = false;
                state.saveTicketConversationInfo = payload;
                state.saveTicketConversationSuccess = true;
            })
            .addCase(saveTicketConversation.rejected, (state, { payload }) => {
                state.saveTicketConversationLoading = false;
                state.saveTicketConversationError = payload;
                state.saveTicketConversationSuccess = false;
                state.saveTicketConversationInfo = null;
            })
            .addCase(getTicketConversation.pending, (state) => {
                state.getTicketConversationLoading = true;
                state.getTicketConversationError = null;
                state.getTicketConversationSuccess = false;
                state.getTicketConversationInfo = null;
            })
            .addCase(getTicketConversation.fulfilled, (state, { payload }) => {
                state.getTicketConversationLoading = false;
                state.getTicketConversationInfo = payload;
                state.getTicketConversationSuccess = true;
            })
            .addCase(getTicketConversation.rejected, (state, { payload }) => {
                state.getTicketConversationLoading = false;
                state.getTicketConversationError = payload;
                state.getTicketConversationSuccess = false;
                state.getTicketConversationInfo = null;
            });
    },
});
export const { resetSaveTicketState } = securitySlice.actions;
export default securitySlice.reducer;
